import { render } from "./TabActivity.vue?vue&type=template&id=ee6f2496&scoped=true"
import script from "./TabActivity.vue?vue&type=script&lang=js"
export * from "./TabActivity.vue?vue&type=script&lang=js"

import "./TabActivity.vue?vue&type=style&index=0&id=ee6f2496&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee6f2496"]])

export default __exports__